import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "map-marker-solid",
  "use": "map-marker-solid-usage",
  "viewBox": "0 0 18 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 22\" id=\"map-marker-solid\"><defs><style>#map-marker-solid .cls-1{fill:#f03e3e;}#map-marker-solid .cls-2{fill:#c92a2a;}</style></defs><title>map-pin</title><path class=\"cls-1\" d=\"M21,10c0,7-9,13-9,13S3,17,3,10a9,9,0,0,1,18,0Z\" transform=\"translate(-3 -1)\" /><circle class=\"cls-2\" cx=\"9\" cy=\"9\" r=\"3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol